export default [
  {
    key: "companyLogo",
    label: "field.image",
    initKey: "companyLogo",
    rules: "size:10000",
    type: "single-image",
    pw: 150,
    ph: 150,
    fullWidth: false,
    cols: 12,
  },
  {
    key: "timeout",
    label: "field.callTimeout",
    initKey: "timeout",
    rules: "required|max:100",
    type: "number",
    cols: 12,
  },
  {
    key: "primaryColor",
    label: "field.primaryColor",
    initKey: "primaryColor",
    rules: "required|max:10",
    type: "color-picker",
    cols: "auto",
    cols: 12,
  },
];
